/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="85.95"
        height="95.47"
        viewBox="0 0 85.95 95.47"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M38.92.32a1.24 1.24 0 0 1 1.67 0C50.8 9.5 62.98 14.05 78.31 14.5a1.25 1.25 0 0 1 1.2 1.12v19.5a1.25 1.25 0 0 1-1.28 1.22 1.27 1.27 0 0 1-1.22-1.29l.05-2V16.96h-.27c-14.72-.7-26.71-5.21-36.82-13.89l-.18-.15-.17.15c-10 8.54-21.7 13-36.09 13.85h-1v14q0 2.46.06 4.77v1.53C3 48.82 4.65 57.75 8.33 65.81l.24.52C14.13 78.2 24 87.03 39.5 92.75l.25.09.46-.17a69.16 69.16 0 0 0 11.78-5.62l.69-.42a1.25 1.25 0 0 1 1.33 2.11A71.67 71.67 0 0 1 40.2 95.4a1.37 1.37 0 0 1-.85 0c-16.5-5.93-27.09-15.3-33-28a63.83 63.83 0 0 1-5.3-18.8l-.17-1.33a134 134 0 0 1-.84-15.52v-16a1.25 1.25 0 0 1 1.2-1.25c15.29-.45 27.51-5 37.72-14.18Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M63.2 44.19a1.25 1.25 0 0 1 1.24 1.13v12.8h12.9a1.26 1.26 0 0 1 1.25 1.12v.13a1.26 1.26 0 0 1-1.12 1.25H63.2a1.24 1.24 0 0 1-1.24-1.12V45.44a1.25 1.25 0 0 1 1.24-1.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M69.2 74.35a1.25 1.25 0 0 1 2.2 1.18l-.06.12-3.71 6.1a1.24 1.24 0 0 1-1.7.43 1.27 1.27 0 0 1-.49-1.6l.11-.07Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M65.33 80.72a1.25 1.25 0 0 1 1.45-.84h.12l6.91 2.18a1.25 1.25 0 1 1-.63 2.42h-.12l-6.86-2.19a1.24 1.24 0 0 1-.82-1.56Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M65.81 37.5a1.26 1.26 0 0 1 1.47-1 23.28 23.28 0 0 1-.55 45.74 1.25 1.25 0 1 1-.54-2.44h.11a20.78 20.78 0 0 0 .49-40.83 1.24 1.24 0 0 1-.98-1.47Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M40.72 61.44a1.24 1.24 0 0 1 1.42 1 20.82 20.82 0 0 0 17.69 17.45 1.252 1.252 0 1 1-.35 2.48 23.32 23.32 0 0 1-19.81-19.51 1.24 1.24 0 0 1 1-1.42ZM60.07 36.3a1.252 1.252 0 1 1 .41 2.47h-.12A20.54 20.54 0 0 0 42.2 56.29a1.25 1.25 0 0 1-2.48-.31s0-.05 0-.07A23 23 0 0 1 60.07 36.3Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithClock180ArrowIcon';

export default Icon;
